//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





import UMUM from "../../library/umum";
import DATA_MASTER from "../../library/dataMaster";

// import { ref } from 'vue'


export default {
  props: ["biodata_id", "nip"],
  data() {
    
    return {
      // xbiodata_id : this.biodata_id,
      list_riwayat: [],
      
      mdl_detil_riwayat: false,
      mdl_detil_riwayat_add: false,
      mdl_detil_riwayat_add_lampiran: false,
      mdl_detil_riwayat_edit: false,
      mdl_detil_riwayat_hapus: false,
      file_old :'',

      UMUM: UMUM,
      DATA_MASTER: DATA_MASTER,

      btn_add: false,



      // ====================================== INTEGRASI SIASN ====================================

      formRiwayatSIASN : {
        eselon : '',
        eselonId : '',
        id : '',
        idPns : '',
        instansiKerjaId : '',
        instansiKerjaNama : '',
        jabatanFungsionalId : '',
        jabatanFungsionalNama : '',
        jabatanFungsionalUmumId : '',
        jabatanFungsionalUmumNama : '',
        jenisJabatan : '',
        namaJabatan : '',
        namaUnor : '',
        nipBaru : '',
        nipLama : '',
        nomorSk : '',
        path : '',
        satuanKerjaId : '',
        satuanKerjaNama : '',
        tanggalSk : '',
        tmtJabatan : '',
        tmtPelantikan : '',
        unorId : '',
        unorIndukId : '',
        unorIndukNama : '',
        unorNama : '',
      },

      data : {
          riwayat_jabatan_struktural_id : '',
          jabatan : '',
          nama_jabatan : '',
          unit_kerja : '',
          esselon_id : '',
          esselon : '',
          tmt_jabatan : '',
          penanda_tangan_sk : '',
          no_sk : '',
          tgl_sk : '',
          biodata_id : '',
          file : null,
          userId : 0,
          createdAt : '',
          biodata_id : '',

      },


      profileSIASN : null,
      loadSIA : true,
      loadRiwayatSIA : true,
      fileLoadSIA :true,
      fileLoadEmpty : false,
      list_riwayat_siaAsn : [],
      fileRiwayat : null,
      kodeDok : '872',
      // ====================================== INTEGRASI SIASN ====================================


      tab: 'disetujui'

    };
  },

  methods: {


    getRiwayat: function(){
        fetch(this.$store.state.url.URL_simpeg_riwayat_jabatan_struktural+'view', {
            method : 'POST',
            headers : {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body : JSON.stringify({
              biodata_id : this.biodata_id,
            })
        }).then((res) => res.json()).then((res_data) => {
          this.list_riwayat_siaAsn = res_data;
          console.log(res_data);
          // this.formRiwayatSIASN.idPns = res_data[0].idPns
        })
    },


    getRiwayatSIASN: async function() {

        this.loadRiwayatSIA = true
        fetch(this.$store.state.url.URL_simpeg_riwayat_jabatan_struktural + "si_asn_viewOne", {
            method: "POST",
            headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                nip: this.nip,
                biodata_id : this.biodata_id
            })
            })
            .then(res => res.json())
            .then(res_data => {
                console.log(res_data)
                this.loadRiwayatSIA = false
                this.list_riwayat_siaAsn = res_data;

                this.formRiwayatSIASN.idPns = res_data[0].idPns
                // this.getRiwayat();
                // 


                // console.log('=====================');
                // console.log(this.list_riwayat_siaAsn);

        });


    },

    addDataSIASN : function(number) {


      fetch(this.$store.state.url.URL_simpeg_riwayat_jabatan_struktural + "si_asn_create", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify(this.formRiwayatSIASN)
      })
        .then(res => res.json())
        .then(res_data => {
          this.list_data = res_data.data;
          this.page_last = res_data.jml_data;
          this.cek_load_data = false;
        });
      
    },


    createRiwayatSIASN : function(number) {
      var formData = new FormData();

      formData.append('id_riwayat', this.formRiwayatSIASN.id);
      formData.append('id_ref_dokumen', this.kodeDok);
      formData.append('file', this.data.file);

      fetch(this.$store.state.url.URL_simpeg_riwayat_jabatan_struktural+'si_asn_uploadFile', {
            method: "POST",
            headers: {
                authorization : 'kikensbatara '+localStorage.token
            },
            body: formData
        }).then((res_data) => {
            this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
            this.getRiwayatSIASN();
        }
      );
    
    },

    getDownloadSIASN: async function(file,kode) {

        
        if (file.path == null || file.path == undefined) {
          this.fileLoadEmpty = true
          console.log("FILE KOSONG");
        } else {
          this.fileLoadEmpty = false


          console.log(file);
          
          var fileGet = file.path[kode].dok_uri
          this.fileLoadSIA = true
          fetch(this.$store.state.url.URL_simpeg_home + "lampiran", {
              method: "POST",
              headers: {
                  "content-type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  fileURL: fileGet,
                  id : file.id,
              })
              })
              .then(response => response.text())
              .then(res_data => {
    
    
                  console.log("INI DIA");
                  console.log(res_data)
                  console.log("INI DIA");
                  console.log(typeof(res_data));
    
                  this.fileRiwayat = res_data
                  this.fileLoadSIA = false
    
                
    
          });




        }


    },

      alertku: function(message, positive, icon) {
        this.$q.notify({
          message: message,
          color: positive,
          icon: icon,
          position: "top",
          timeout: 500
        });
    },

    selectRiwayatSIASN: function(data){
      console.log(data);



        this.formRiwayatSIASN.eselon = data.eselon;
        this.formRiwayatSIASN.eselonId = data.eselonId;
        this.formRiwayatSIASN.id = data.id;
        this.formRiwayatSIASN.idPns = data.idPns;
        this.formRiwayatSIASN.instansiKerjaId = data.instansiKerjaId;
        this.formRiwayatSIASN.instansiKerjaNama = data.instansiKerjaNama;
        this.formRiwayatSIASN.jabatanFungsionalId = data.jabatanFungsionalId;
        this.formRiwayatSIASN.jabatanFungsionalNama = data.jabatanFungsionalNama;
        this.formRiwayatSIASN.jabatanFungsionalUmumId = data.jabatanFungsionalUmumId;
        this.formRiwayatSIASN.jabatanFungsionalUmumNama = data.jabatanFungsionalUmumNama;
        this.formRiwayatSIASN.jenisJabatan = data.jenisJabatan;
        this.formRiwayatSIASN.namaJabatan = data.namaJabatan;
        this.formRiwayatSIASN.namaUnor = data.namaUnor;
        this.formRiwayatSIASN.nipBaru = data.nipBaru;
        this.formRiwayatSIASN.nipLama = data.nipLama;
        this.formRiwayatSIASN.nomorSk = data.nomorSk;
        this.formRiwayatSIASN.path = data.path;
        this.formRiwayatSIASN.satuanKerjaId = data.satuanKerjaId;
        this.formRiwayatSIASN.satuanKerjaNama = data.satuanKerjaNama;
        this.formRiwayatSIASN.tanggalSk = data.tanggalSk;
        this.formRiwayatSIASN.tmtJabatan = data.tmtJabatan;
        this.formRiwayatSIASN.tmtPelantikan = data.tmtPelantikan;
        this.formRiwayatSIASN.unorId = data.unorId;
        this.formRiwayatSIASN.unorIndukId = data.unorIndukId;
        this.formRiwayatSIASN.unorIndukNama = data.unorIndukNama;
        this.formRiwayatSIASN.unorNama = data.unorNama;




    },




    filterInstansi : function (val, update, abort) {
      update(() => {
        if (val === '') {}
          else {
            // console.log(val);
            DATA_MASTER.getInstansi_SIASN(val)
          }
      })
    },

    filterJabfung : function (val, update, abort) {
      update(() => {
        if (val === '') {}
          else {
            // console.log(val);
            DATA_MASTER.getJabatanFungsional_SIASN(val)
          }
      })
    },

    filterJabUm : function (val, update, abort) {
      update(() => {
        if (val === '') {}
          else {
            // console.log(val);
            DATA_MASTER.getJabatanFungsionalUmum_SIASN(val)
          }
      })
    },

    filterUnor : function (val, update, abort) {
      update(() => {
        if (val === '') {}
          else {
            // console.log(val);
            DATA_MASTER.getUnor_SIASN(val)
          }
      })
    },

    Notify: function(message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: "top",
        timeout: 500
      });
    },

  },


  mounted () {

    console.log(this.biodata_id);
    // this.getRiwayat()
    // this.getRiwayat()
    this.getRiwayatSIASN()
    // DATA_MASTER.getGolongan();
    // DATA_MASTER.getEsselon();
  },



};
